import { ResponseFormat, type VoiceUrls } from "../../types";

export const getAllowTextFallback = (
  responseFormat: ResponseFormat | undefined,
): boolean => responseFormat !== ResponseFormat.VoiceRequired;

export const getCanSwitchToVoice = (
  voiceUrls: VoiceUrls | undefined,
  responseFormat: ResponseFormat | undefined,
): boolean => !!voiceUrls && responseFormat === ResponseFormat.VoiceRecommended;
